export const OVERVIEW_VIEW_TRANSLATION_EN = {
  details: 'Order details',
  appointments: 'Appointments',
} as const;
